import { format, formatDistanceToNow } from "date-fns"
import { de } from "date-fns/locale/de"
import { interpretAsGermanTimeIso } from "./germanTime"

export function formatDateMedium(date: Date | string) {
  const dateObj = new Date(date)

  dateObj.setHours(12)

  return format(dateObj, "P", { locale: de })
}

export function formatDateAgo(date: Date | string) {
  const dateObj = new Date(date)

  return formatDistanceToNow(dateObj, { locale: de, addSuffix: true })
}

export function formatProductFulfillmentFromToIso(formattedDate: string | undefined) {
  if (!formattedDate) {
    return ""
  }

  const [day, month, year] = formattedDate.split(".").map((part) => +part)

  if (
    typeof year !== "number" ||
    typeof month !== "number" ||
    typeof day !== "number" ||
    Number.isNaN(year) ||
    Number.isNaN(month) ||
    Number.isNaN(day)
  ) {
    throw new Error(`Invalid date: ${formattedDate}`)
  }

  const yearString = year.toString()
  const monthString = month.toString().padStart(2, "0")
  const dayString = day.toString().padStart(2, "0")
  const dateStringIso = `${yearString}-${monthString}-${dayString}`

  return interpretAsGermanTimeIso(dateStringIso)
}
